export default function StartOrSkip2FARegistration({ onNext, onFinish, registrationState }) {

    return <div className="flex flex-col gap-3">
         <h1 className="font-bold">2 factor authenticatie activeren</h1>
        <p>
            Om aan de eisen van de Algemene verordening gegevensbescherming (AVG) te voldoen wordt een extra beveiliging ingevoerd in de vorm van ‘2 Factor authenticatie’.
            Dit betekent dat u bij het inloggen op het portaal van U Staat Centraal (Zorgconnect) uw telefoon bij de hand dient te houden om via de gratis App ‘google authenticator’ een verspringende code in te voeren.
            Hiervoor dient deze app gekoppeld te worden aan uw account.
        </p>
        <p>
            U heeft nog geen 2 factor authenticatie ingeschakeld, wij verzoeken u dit direct in te schakelen.
        </p>
        <p>
            Wilt u 2 factor authenticatie nu inschakelen klik dan op volgende en houdt uw telefoon bij de hand. Voer dit proces bij voorkeur uit op een computer
        </p>
        <div className="flex flex-row gap-3 w-full">
            <button className="flex-1 px-3 py-2 bg-green-500 text-white" onClick={() => onNext()}>Volgende</button>
        </div>
    </div>
}